<template>
  <modal :show.sync="localShow" :modalContentClasses="{ 'p-0': true }">
    <h6 slot="header" class="modal-title">{{ title }}</h6>

    <div class="px-4 py-4 text-center">
      <p class="font-weight-500 font-size-18 mb-2 text-center"> {{ message }} </p>
      <p class="text-muted mb-0" v-if="subtitle">{{ subtitle }}</p>
    </div>

    <template slot="footer">
      <div class="w-100 text-center py-3">
        <base-button v-if="primaryText" :type="primaryType" @click="onPrimary">{{ primaryText }}</base-button>
        <base-button v-else type="main-color" @click="onPrimary">確定</base-button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import BaseButton from "@/components/BaseButton.vue";

export default {
  name: "NoticeDialog",
  components: { Modal, BaseButton },
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    primaryText: { type: String, default: '' },
    primaryType: { type: String, default: 'main-color' },
  },
  computed: {
    localShow: {
      get() { return this.show; },
      set(v) { this.$emit('update:show', v); },
    },
  },
  methods: {
    onPrimary() {
      this.$emit('primary');
      this.$emit('update:show', false);
    },
  },
};
</script>

<style scoped>
.modal-header {
  border-bottom: none !important;
}
.modal-footer {
  border-top: none !important;
}
</style>


